var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountMultipleOutline = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.892 8.675a4.167 4.167 0 000-4.85 2.825 2.825 0 011.608-.492 2.917 2.917 0 010 5.834 2.825 2.825 0 01-1.608-.492zM4.583 6.25a2.917 2.917 0 115.834 0 2.917 2.917 0 01-5.834 0zm1.667 0a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm7.083 7.917v1.666H1.667v-1.666s0-3.334 5.833-3.334 5.833 3.334 5.833 3.334zm-1.666 0c-.117-.65-1.109-1.667-4.167-1.667s-4.108 1.092-4.167 1.667m9.959-3.334A4.432 4.432 0 0115 14.167v1.666h3.333v-1.666s0-3.025-5.05-3.334h.009z"
  })));
};
export default SvgAccountMultipleOutline;